import { createSelector } from 'reselect'

const getWorkflowState = state => state.workflow

export const getWorkflowSteps = createSelector(
  getWorkflowState,
  workflowState => workflowState.steps
)
